<template>
  <div class="p-4 overflow-auto">
    <content-spinner :show="adGroups.loading" />
    <div class="d-flex flex-column">
      <h3>Active Directory Groups</h3>
      <div class="row mt-2">
        <div
          v-for="adGroup in adGroups.data"
          class="col-md-6 col-lg-4 col-xl-3 mb-3"
        >
          <b-card
            :key="adGroup.id"
            class="dashboard-item"
          >
            {{ adGroup.displayName || adGroup.id }}
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../core/components/ContentSpinner';

const {mapState} = createNamespacedHelpers('user');
export default {
  name: 'ProfileView',
  components: {ContentSpinner},
  computed: {
    ...mapState(['adGroups']),
  },
};
</script>

<style scoped>

</style>